(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[742],{

/***/ 30317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(8645);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ForgotPassword; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 26 modules
var yup_es = __webpack_require__(65413);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/form-fields/styles.ts
var styles = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/components/uielements/formik/index.tsx + 3 modules
var formik = __webpack_require__(83269);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/constants/validation.ts
var validation = __webpack_require__(38885);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var actions = __webpack_require__(45479);
// EXTERNAL MODULE: ./src/redux/auth/reducer.ts
var reducer = __webpack_require__(7481);
;// CONCATENATED MODULE: ./src/components/app/authForms/forgot-password.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        "px;\n  @media (max-width: 767px) {\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













// Validation schema for the barcode submission form.
var forgotPasswordSchema = (0,yup_es/* object */.Ry)({
    // The email must be valid and present.
    email: (0,yup_es/* string */.Z_)().email(validation/* VALIDATION_STRINGS.EMAIL */.xz.EMAIL).required(validation/* VALIDATION_STRINGS.REQUIRED */.xz.REQUIRED)
});
/**
 * Form to send an email with a link to reset a user's password.
 *
 * @TODO during Stitches overhaul, inline the SubmitButton style override.
 */ function ForgotPasswordForm() {
    var dispatch = (0,es.useDispatch)();
    var loading = (0,es.useSelector)(reducer/* authSliceSelector */.$K).loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: function(param, param1) {
            var email = param.email, resetForm = param1.resetForm;
            // Dispatch the action then reset the form.
            dispatch(actions/* default.forgotPassword */.Z.forgotPassword(email));
            resetForm();
        },
        initialValues: {
            email: ""
        },
        validationSchema: forgotPasswordSchema,
        children: function(param) {
            var dirty = param.dirty, isValid = param.isValid;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik/* Form */.l, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledFormField */.Ll, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik/* Input */.I, {
                            id: "email",
                            name: "email",
                            type: "email",
                            label: "Email",
                            autoFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton, {
                        disabled: !dirty || !isValid,
                        submitting: loading,
                        type: "submit",
                        buttonTheme: "secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: loading ? "forgot_password.submit_cta_loading" : "forgot_password.submit_cta"
                        })
                    })
                ]
            });
        }
    });
}
var SubmitButton = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-3e5c584d-0"
})(_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER);

// EXTERNAL MODULE: ./src/components/app/authForms/layout/styles.tsx
var layout_styles = __webpack_require__(61098);
// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/uielements/hr/index.ts
var hr = __webpack_require__(51912);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./pages/forgot-password.tsx












function ForgotPassword() {
    var webConfig = (0,cmsConfig/* useWebConfig */.JR)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        backgroundOverride: true,
        disabled: (0,stringHelpers/* safelyGetConfig */.K6)(webConfig, "accounts.disable_accounts"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_styles/* StyledAuthPageLayout */.e, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_styles/* StyledAuthPageContent */.x, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "h1",
                        accessor: "forgot_password.header",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "h3",
                        accessor: "forgot_password.subheader",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hr/* StyledHr */.n, {
                        background: "transparent"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hr/* StyledHr */.n, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "signup.prompt",
                                html: true
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: routes/* ROUTES.SIGN_UP */.Z6.SIGN_UP,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: function() {
                                        return (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__CLICK_SIGN_UP */.x.AUTH__CLICK_SIGN_UP);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        accessor: "signup.cta"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 61098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ StyledAuthPageLayout; },
/* harmony export */   "x": function() { return /* binding */ StyledAuthPageContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: calc(100vh - ",
        "px);\n\n  @media (max-width: 767px) {\n    background-color: ",
        ";\n    min-height: calc(100vh - ",
        "px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAuthPageLayout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44565f4c-0"
})(_templateObject(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT * 2, function(param) {
    var theme = param.theme;
    return theme.auth_page.background_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT * 2);
var _background_color, _border_color, _border_radius, _background_color1;
var StyledAuthPageContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44565f4c-1"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.auth_page.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid ".concat((_border_color = theme.auth_page.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.auth_page.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        margin: "0 auto",
        maxWidth: "".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MEDIUM_CONTENT */ ._.MEDIUM_CONTENT, "px"),
        padding: "40px 20px",
        textAlign: "center",
        width: "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.font)), {
        h1: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            margin: 0
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.secondary_font)),
        h3: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.font, [
            "color",
            "font_family",
            "font_size",
            "font_style",
            "line_height", 
        ])), {
            fontWeight: "normal",
            margin: 0
        }),
        p: {
            margin: "20px 0 0"
        },
        a: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            textDecoration: "underline",
            transition: "opacity 0.2s linear"
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.tertiary_font)), {
            "&:hover": {
                opacity: 0.7
            }
        }),
        "@media (max-width: 767px)": {
            borderColor: (_background_color1 = theme.auth_page.background_color) !== null && _background_color1 !== void 0 ? _background_color1 : "transparent"
        }
    });
});


/***/ }),

/***/ 83269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ Form; },
  "I": function() { return /* reexport */ Input; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/uielements/forms/field-error.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: absolute;\n  top: ",
        "px;\n  font-size: 12px;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FieldError = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    role: "alert"
}).withConfig({
    componentId: "sc-4e59cc64-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.error_color;
}, function(param) {
    var theme = param.theme;
    return theme.forms.field_height;
}, function(param) {
    var hidden = param.hidden;
    return hidden && "\n    display: none;\n  ";
});

// EXTERNAL MODULE: ./src/components/uielements/forms/input.tsx
var input = __webpack_require__(23889);
;// CONCATENATED MODULE: ./src/components/uielements/formik/input.tsx







// eslint-disable-next-line react/display-name
var Input = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    // @ts-expect-error: props doesn't match what formik expects
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,formik_esm/* useField */.U$)(props), 2), field = _$ref[0], _$ref1 = _$ref[1], error = _$ref1.error, touched = _$ref1.touched;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({
                ref: ref
            }, field, props)),
            touched && error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError, {
                children: error
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/uielements/formik/form.tsx

function form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: start;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Form = (0,styled_components_browser_esm/* default */.ZP)(formik_esm/* Form */.l0).withConfig({
    componentId: "sc-f572903-0"
})(form_templateObject());

;// CONCATENATED MODULE: ./src/components/uielements/formik/index.tsx




/***/ }),

/***/ 23889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_visually_hidden__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41969);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40813);





// eslint-disable-next-line react/display-name
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_visually_hidden__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .f, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: props.id,
                    children: props.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledInput */ .F, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref
            }, props))
        ]
    });
});


/***/ }),

/***/ 40813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);





var _background_color, _border_radius, _border_color;
var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-a2abffdc-0"
})(function(param) {
    var theme = param.theme, width = param.width;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.forms.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        borderRadius: "".concat((_border_radius = theme.forms.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        border: "1px solid ".concat((_border_color = theme.forms.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        height: "".concat(theme.forms.field_height, "px"),
        padding: "0 var(--size-3)",
        width: width !== null && width !== void 0 ? width : "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.forms.font, [
        "color",
        "font_family",
        "font_size"
    ])), {
        "@media (max-width: 767px)": {
            fontSize: "16px",
            width: "100%"
        },
        "::-webkit-input-placeholder": {
            /* Chrome/Opera/Safari */ color: theme.forms.placeholder_color
        },
        "::-moz-placeholder": {
            /* Firefox 19+ */ color: theme.forms.placeholder_color
        },
        ":-ms-input-placeholder": {
            /* IE 10+ */ color: theme.forms.placeholder_color
        },
        ":-moz-placeholder": {
            /* Firefox 18- */ color: theme.forms.placeholder_color
        },
        "&:focus-within": {
            borderColor: theme.global.primary_active_color
        },
        "&:disabled": {
            background: _constants_styles__WEBPACK_IMPORTED_MODULE_0__/* .COLORS.LIGHTGRAY */ .DM.LIGHTGRAY,
            cursor: "not-allowed"
        }
    });
});


/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ StyledHr; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  display: block;\n  height: 1px;\n  border: 0;\n  margin: ",
        "px 0;\n  padding: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledHr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-d8fdad27-0"
})(_templateObject(), function(param) {
    var background = param.background, theme = param.theme;
    return background || theme.global.primary_border_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.MEDIUM */ .jl.MEDIUM);


/***/ }),

/***/ 41969:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ $ea1ef594cf570d83$export$be92b6f5f03c0fe9; }
/* harmony export */ });
/* unused harmony export VisuallyHidden */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72714);







/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const $ea1ef594cf570d83$export$439d29a4e110a164 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_1__/* .Primitive.span */ .WV.span, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($ea1ef594cf570d83$export$439d29a4e110a164, {
    displayName: $ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;





//# sourceMappingURL=index.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,513,372,443,593,588,356,774,888,179], function() { return __webpack_exec__(30317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);